/*
	Szerokość klasycznego paska przewijania w `--sbw`.

	Cały front skaluje się od szerokości okna (patrz `styles/utils/_scale.scss`),
	a `100vw` LICZY pasek przewijania. Na systemach, gdzie pasek zajmuje miejsce
	w layoucie (macOS „Pokaż paski przewijania: zawsze”, Windows), sekcje pełnej
	szerokości wychodziły poza widoczny obszar i strona dostawała poziomy scroll.
	Stąd `--vwu` = `100vw - var(--sbw)`, czyli realna szerokość treści.
*/

const setScrollbarWidth = () => {
    const width = window.innerWidth - document.documentElement.clientWidth;

    // pasek nakładkowy (macOS domyślnie, mobile) daje 0 — wtedy `--vwu` == `100vw`
    document.documentElement.style.setProperty('--sbw', `${Math.max(0, width)}px`);
};

setScrollbarWidth();
window.addEventListener('resize', setScrollbarWidth);
window.addEventListener('load', setScrollbarWidth);
